import { Box, useTheme } from "@mui/material";
import React from "react";
import { createClickHandler } from "../calendar";
import { createUrlString } from "../../url";

const resourceDefaultGrey = "#B2C6DE";
const defaultBgnd = "#F4F7FE";

export const slotStatus = {
  WAITING: "waiting",
  EMPTY: "empty",
  TREATING: "treating",
  TREATED: "treated",
  LOCKED: "locked",
};

function EmptySlot({ n, children }) {
  const theme = useTheme();

  return (
    <Box
      className={`calendar-slot calendar-slot-${n}`}
      sx={{
        flexGrow: 1,
        flexShrink: 1,
        width: 0,
        borderColor: resourceDefaultGrey,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.main,
        cursor: "default",
      }}
    >
      {children}
    </Box>
  );
}

function LockedSlot({ n, children }) {
  const theme = useTheme();

  return (
    <Box
      className={`calendar-slot calendar-slot-${n}`}
      sx={{
        flexGrow: 1,
        flexShrink: 1,
        width: 0,
        borderColor: "transparent",
        backgroundColor: theme.palette.background.darker,
        color: resourceDefaultGrey,
        cursor: "default",
      }}
    >
      {children}
    </Box>
  );
}

function WaitingSlot({ n, children, setEditEvent, appointments }) {
  const theme = useTheme();
  const clickHandler = createClickHandler({
    onClick: () => setEditEvent?.(appointments),
    onDoubleClick: () => {
      if (appointments.length !== 1) {
        return;
      }

      const clientId = appointments[0].client?.id;
      if (clientId == null) {
        return;
      }

      window.open(
        createUrlString(
          location.origin,
          location.search,
          `/clients/${clientId}`,
        ),
        "_blank",
      );
    },
  });

  return (
    <Box
      className={`calendar-slot calendar-slot-${n}`}
      sx={{
        flexGrow: 1,
        flexShrink: 1,
        width: 0,
        borderColor: resourceDefaultGrey,
        backgroundColor: defaultBgnd,
        color: theme.palette.primary.contrastText,
        cursor: setEditEvent == null ? null : "pointer",
      }}
      onClick={clickHandler}
    >
      {children}
    </Box>
  );
}

function TreatingSlot({ n, children, setEditEvent, appointments }) {
  const theme = useTheme();
  const clickHandler = createClickHandler({
    onClick: () => setEditEvent?.(appointments),
    onDoubleClick: () => {
      if (appointments.length !== 1) {
        return;
      }

      const clientId = appointments[0].client?.id;
      if (clientId == null) {
        return;
      }

      window.open(
        createUrlString(
          location.origin,
          location.search,
          `/clients/${clientId}`,
        ),
        "_blank",
      );
    },
  });

  return (
    <Box
      className={`calendar-slot calendar-slot-${n}`}
      sx={{
        flexGrow: 1,
        flexShrink: 1,
        width: 0,
        borderColor: resourceDefaultGrey,
        backgroundColor: defaultBgnd,
        color: theme.palette.primary.contrastText,
        cursor: setEditEvent == null ? null : "pointer",
      }}
      onClick={clickHandler}
    >
      {children}
    </Box>
  );
}

const statusToSlotComponent = {
  [slotStatus.EMPTY]: EmptySlot,
  [slotStatus.LOCKED]: LockedSlot,
  [slotStatus.WAITING]: WaitingSlot,
  [slotStatus.TREATING]: TreatingSlot,
  [slotStatus.TREATED]: TreatingSlot,
};

export default function Slot(props) {
  const S = statusToSlotComponent[props.variant];

  return <S {...props} />;
}
